<template>
  <div class="more-homo">
    <common-bg-plate>
      <change-chain></change-chain>
      <div class="user-content">
        <paillier ref="paillier"></paillier>
      </div>
    </common-bg-plate>
  </div>
</template>
<script>
import changeChain from '../../privacyComputing/components/changeChain.vue'
import paillier from '../../blockchain/paillier/index'
export default {
  components: {
    changeChain,
    paillier
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('more-homo', (), ());
.more-homo {
  @include adaptation(
    (
      --more-homo-user-content-padding: 24px 20px
    )
  );
  --more-homo-min-height: var(--base-main-router-body-avaliable-height);
  .common-bg-plate {
    min-height: var(--more-homo-min-height);
    .user-content {
      padding: var(--more-homo-user-content-padding);
    }
  }
}
</style>
